import React, { Component } from 'react';
import { connect } from 'react-redux';
import ShareSummary from '../../components/share-summary';
import money, { Money } from '../../lib/money';

import {
  getOrganizerMembership,
  getCurrentPurchase,
  getCurrentContribution,
  getCommittedMemberships,
} from '../../selectors/purchase-selector';

class ShareSummaryContainer extends Component {
  inviteesShareAmount() {
    const { committedInvitees } = this.props;
    const amounts = committedInvitees.map(i => money(i.shareAmount));
    return Money.sum(amounts);
  }

  contributionsShareAmount() {
    const { committedInvitees } = this.props;
    const contributions = committedInvitees.map(invitee => invitee.currentContribution)
      .filter(contribution => !!contribution)
      .map(contribution => money(contribution.shareAmount));

    return Money.sum(contributions);
  }

  render() {
    return (
      <ShareSummary
        organizerTotalShareAmount={this.props.organizerTotalShareAmount}
        organizerCurrentShareAmount={this.props.organizerCurrentShareAmount}
        inviteesShareAmount={this.inviteesShareAmount()}
        contributionsShareAmount={this.contributionsShareAmount()}
        inviteesSize={this.props.committedInvitees.length}
        payments={this.props.purchase.payments}
        currencyCode={this.props.purchase.currencyCode}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const organizerMembership = getOrganizerMembership(state);

  const organizerTotalShareAmount = organizerMembership.shareAmount;
  const currentContribution = getCurrentContribution(state);
  let organizerCurrentShareAmount = Money.zero(purchase.currencyCode);

  if (currentContribution) {
    organizerCurrentShareAmount = currentContribution.shareAmount;
  }

  const committedInvitees = getCommittedMemberships(state)
    .filter((membership) => membership.id !== organizerMembership.id);

  return {
    organizerMembership,
    organizerTotalShareAmount,
    purchase,
    committedInvitees,
    organizerCurrentShareAmount,
  };
};

export default connect(mapStateToProps)(ShareSummaryContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/make-purchase/share-summary.container.js